import { useCallback, useMemo } from "react";

import { normalizeCountryLabel as resolveCountryLabel } from "../companies/countryLabel";
import { useTypeOptions } from "./useTypeOptions";

/**
 * Country type options + ID→name resolver for companies_country_default / address country fields.
 */
export function useCompanyCountryLabel(countryParent?: number | string | null) {
  const parentId =
    countryParent === undefined || countryParent === null || countryParent === ""
      ? undefined
      : Number(countryParent);

  const rawOptions = useTypeOptions(
    Number.isFinite(parentId as number) ? (parentId as number) : undefined
  );

  const companyCountryOptions = useMemo(
    () => rawOptions ?? [],
    [rawOptions]
  );

  const normalizeCountryLabel = useCallback(
    (value?: string | number | null) =>
      resolveCountryLabel(value, companyCountryOptions),
    [companyCountryOptions]
  );

  return { companyCountryOptions, normalizeCountryLabel };
}
